exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.font__bold[data-v-449470ae] {\n    font-weight: bold;\n}\n.line__text[data-v-449470ae] {\n    -webkit-text-decoration: dotted;\n            text-decoration: dotted;\n    -webkit-text-decoration-line: underline;\n            text-decoration-line: underline;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-449470ae","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/professional/IroningTableConsent.vue
// module id = 1962
// module chunks = 0